import App from '@atlassian/jira-software-burnup-report';
import { createReportPageBootstrap } from '@atlassian/jira-spa-apps-next-gen-reports-page';

export default createReportPageBootstrap('burnup', App);
